import { ReactNode } from "react";

import { Box, Stack, Typography } from "@mui/material";

interface AppPageHeaderProps {
  title: string;
  subtitle?: string;
  action?: ReactNode;
}

const AppPageHeader = ({
  title,
  subtitle,
  action,
}: AppPageHeaderProps) => {
  return (
    <Box
      mb={3}
      sx={{
        display: "flex",
        alignItems: "center",
        minHeight: 58,
        pb: 2.5,
        borderBottom: "1px solid",
        borderColor: "divider",
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
      >
        <Box>
          <Typography variant="h4" fontWeight={800} color="text.primary" sx={{ letterSpacing: 0 }}>
            {title}
          </Typography>

          {subtitle && (
            <Typography
              variant="body2"
              color="text.secondary"
              mt={0.75}
              sx={{ maxWidth: 720 }}
            >
              {subtitle}
            </Typography>
          )}
        </Box>

        {action && <Box>{action}</Box>}
      </Stack>
    </Box>
  );
};

export default AppPageHeader;
